import React from "react";

/**
 * Extracted from AgentDashborad.jsx so both desktop and the mobile
 * "Inicio" screen draw the exact same face (not a simplified stand-in).
 */
const MoodFace = ({ value, color, size = 34 }) => {
  const mouths = {
    1: "M9 16.5c1-1.8 2.6-2.6 3-2.6s2 0.8 3 2.6",
    2: "M9 15.8c1-1 2.6-1.4 3-1.4s2 0.4 3 1.4",
    3: "M8.5 15h7",
    4: "M8.3 14c1.2 1.9 2.7 2.4 3.7 2.4s2.5-0.5 3.7-2.4",
    5: "M7.8 13c1.5 3 3.1 3.8 4.2 3.8s2.7-0.8 4.2-3.8",
  };
  return (
    <svg width={size} height={size} viewBox="0 0 24 24">
      <circle cx="12" cy="12" r="10.5" fill={`${color}26`} stroke={color} strokeWidth="1.5" />
      <circle cx="6.3" cy="13.8" r="1.7" fill={`${color}66`} />
      <circle cx="17.7" cy="13.8" r="1.7" fill={`${color}66`} />
      {value === 5 ? (
        <>
          <path d="M6.8 9.2c0.9-0.9 2.2-0.9 3.1 0" stroke={color} strokeWidth="1.7" fill="none" strokeLinecap="round" />
          <path d="M14.1 9.2c0.9-0.9 2.2-0.9 3.1 0" stroke={color} strokeWidth="1.7" fill="none" strokeLinecap="round" />
        </>
      ) : (
        <>
          <circle cx="8.2" cy="9.4" r="1.4" fill={color} />
          <circle cx="15.8" cy="9.4" r="1.4" fill={color} />
        </>
      )}
      <path d={mouths[value]} stroke={color} strokeWidth="1.8" fill="none" strokeLinecap="round" />
    </svg>
  );
};

export default MoodFace;
